import { render, staticRenderFns } from "./sicknessdetails.vue?vue&type=template&id=012b70c7"
import script from "./sicknessdetails.vue?vue&type=script&lang=js"
export * from "./sicknessdetails.vue?vue&type=script&lang=js"
import style0 from "./sicknessdetails.vue?vue&type=style&index=0&id=012b70c7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports